















































































































































































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import BaseContainer from '@/components/BaseContainer.vue';
import { formRules } from '@/common/util/validator';
import { UserApi, LoginApi } from '@/http';
import { MessageBox, Message } from 'element-ui';
@Component({
    components: {
        BaseContainer,
    },
})
export default class PWEdit extends Vue {
    public $refs: {
        form: HTMLFormElement;
        repeatForm: HTMLFormElement;
    };
    // 验证规则
    public formRules = formRules;
    public active: number = 1;
    public disYzm: boolean = true;
    public canShow: boolean = true;
    public toastText: string = '';
    public firstTep: boolean = true;
    public title: string = '修改密码';
    public reTitle: string = '重置密码';
    public form = {
        id: '',
        oldPassword: '',
        password: '',
        repeatPassword: '',
    };
    public repeatForm = {
        userId: '',
        userName: '',
        phoneNumber: '',
        code: '',
        password: '',
        rePassword: '',
        type: 0,
    };
    public dialogVisible: boolean = false;
    public repeatVisible: boolean = false;
    public btnMessage: string = '获取验证码';
    public countDowning: boolean = false;
    public created() {}
    public mounted() {
        if (this.repeatForm.phoneNumber != '') {
            this.disYzm = !this.checkMobile(this.repeatForm.phoneNumber);
        } else {
            this.disYzm = true;
        }
    }
    reset() {
        this.form = {
            id: '',
            oldPassword: '',
            password: '',
            repeatPassword: '',
        };
    }
    resetRepeat() {
        this.repeatForm = {
            userId: '',
            userName: '',
            phoneNumber: '',
            code: '',
            password: '',
            rePassword: '',
            type: 0,
        };
    }
    @Prop()
    public userName = '';
    @Prop()
    public phoneNumber = '';

    public uId: string = '';
    public open(id) {
        this.reset();
        this.uId = id;
        this.form.id = id;
        this.dialogVisible = true;
    }
    public saveForm() {
        this.$refs.form.validate(async (valid) => {
            if (valid) {
                if (this.form.password == this.form.oldPassword) {
                    MessageBox.alert('新密码不能与旧密码一致，请核实', '提示', {
                        confirmButtonText: '确定',
                        type: 'warning',
                    }).then(() => {});
                    return;
                }
                if (this.form.password != this.form.repeatPassword) {
                    MessageBox.alert('确认密码与新密码不一致，请核实', '提示', {
                        confirmButtonText: '确定',
                        type: 'warning',
                    }).then(() => {});
                    return;
                }
                await UserApi.UpdatePW({ ...this.form }).then(() => {
                    MessageBox.alert('密码修改成功，请重新登录！', '提示', {
                        confirmButtonText: '确定',
                        type: 'warning',
                        callback: (action) => {
                            MessageBox.close();
                            sessionStorage.clear();
                            localStorage.clear();
                            location.reload();
                            this.$router.push('./login');
                        },
                    });
                });
            }
        });
    }

    @Watch('repeatForm', { deep: true })
    public repeatFormPwdChange(repeatForm) {
        if (repeatForm.phoneNumber == '' || repeatForm.userName == '' || repeatForm.code == '') {
            this.firstTep = true;
        }
        if (repeatForm.userName) {
            if (repeatForm.phoneNumber.length == 11) {
                if (!this.isSend) {
                    this.disYzm = false;
                }
                if (repeatForm.code.length == 4) {
                    this.firstTep = false;
                } else {
                    this.firstTep = true;
                }
            } else {
                this.disYzm = true;
                this.firstTep = true;
            }
        }
    }
    repeat() {
        this.dialogVisible = false;
        this.$refs.form.resetFields();
        this.resetRepeat();
        this.repeatVisible = true;
    }
    public checkMobile(phoneNumber?) {
        var regu = /^1[123456789]\d{9}$/;
        var re = new RegExp(regu);
        if (!!phoneNumber) {
            if (re.test(phoneNumber)) {
                return true;
            } else {
                return false;
            }
        } else {
            if (re.test(this.repeatForm.userName)) {
                return true;
            } else {
                return false;
            }
        }
    }
    /**获取验证码 */
    public isSend: boolean = false;
    getCode() {
        if (!this.disYzm) {
            this.disYzm = true;
            if (this.repeatForm.userName == this.userName && this.repeatForm.phoneNumber == this.phoneNumber) {
                LoginApi.GetCode({
                    phoneNumber: this.repeatForm.phoneNumber,
                }).then((res) => {
                    if (res.extData == 'True') {
                        this.$message.success('验证码已发送！');
                        this.isSend = true;
                        this.countCode();
                    } else {
                        this.isSend = false;
                        this.disYzm = false;
                        this.$message.warning('验证码发送失败！');
                    }
                });
            } else if (this.repeatForm.userName != this.userName) {
                this.$alert('用户名不存在');
            } else if (this.repeatForm.phoneNumber != this.phoneNumber) {
                this.$alert('手机号码不正确');
            }
        }
    }
    /**
     * 倒计时
     */
    public interval: any;
    countCode() {
        this.disYzm = true;
        this.countDowning = true;
        let i = 60;
        this.interval = setInterval(() => {
            this.btnMessage = `${--i}秒后重试`;
            if (i === 0) {
                clearInterval(this.interval);
                this.btnMessage = '获取验证码';
                this.disYzm = false;
                this.isSend = false;
                this.countDowning = false;
            }
        }, 1000);
    }
    // 重置密码
    public firstNext() {
        LoginApi.CheckPhoneCode({ phoneNumber: this.repeatForm.phoneNumber, code: this.repeatForm.code })
            .then((res) => {
                if (res == true) {
                    if (this.active++ > 2) this.active = 1;
                } else {
                    this.$message.warning('验证码不正确！');
                }
            })
            .catch((err) => {
                this.$alert('验证码不正确！');
            });
    }
    public firstBack() {
        this.repeatVisible = false;
        this.reset();
        this.dialogVisible = true;
        this.$nextTick(() => {
            this.$refs.form.resetFields();
        });
    }
    public async secondNext() {
        if (this.repeatForm.password != this.repeatForm.rePassword) {
            this.$alert('确认密码与新密码不一致，请核实');
            return;
        }
        await UserApi.ResetPW({ ...this.repeatForm });
        if (this.active++ > 3) this.active = 1;
    }
    public back() {
        if (this.active++ < 3) this.active = 1;
    }
    public reLogin() {
        if (this.active == 3) {
            sessionStorage.clear();
            localStorage.clear();
            location.reload();
            this.$router.push('./login');
        }
    }
}
